import { fonts } from 'src/views/theme';
import styled from 'styled-components';

export const Heading = styled.h2`
text-align: center;
${ fonts.displaym200 }
margin-bottom: 4.8rem;
`;
